import * as moment from 'moment';
import { MOMENT_BACKEND_DATE_FORMAT } from '../../constants/dateFormats';

export function canGoToStep(state, stepNumber) {
    const isGoingToNextStep = stepNumber > state.step;

    if (isGoingToNextStep) {
        return previousStepsValid(state, stepNumber) && validateStep(state.steps.length, stepNumber) && canGoToStep;
    }
    else {
        return true;
    }
}

export function setTodayIfPastDate(form, key) {
    if (moment(form[key], MOMENT_BACKEND_DATE_FORMAT).isBefore(moment(), 'days')) {
        form[key] = moment().format(MOMENT_BACKEND_DATE_FORMAT);
    }
}

function previousStepsValid(state, stepNumber) {
    for (let i = state.step - 1; i < stepNumber - 1; i++) {
        if (!state.steps[i].valid) {
            return false
        }
    }
    return true;
}

function validateStep(stepsCount, stepNumber) {
    return stepNumber > 0 && stepNumber <= stepsCount;
}


// WEBPACK FOOTER //
// ./src/common/utils/step-form.js